import { Select } from "antd";
import React from "react";
import {ReactComponent as SelectIcon } from "../../assets/img/icons/arrow-down-select.svg"
const Selectbox = ({ label, className, option, ...rest }) => {
  const { Option } = Select;
  return (
    <div className={`Select relative ${className}`}>
      <h6>
        {label}
      </h6>

      <Select {...rest} suffixIcon={<SelectIcon/>}>
        
         { option.map(i =>
            <Option  value={i.value}>
              {i.label}
            </Option>
          )}
      </Select>
    </div>
  );
};

export default Selectbox;
